import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import ServicePage from "@/pages/ServicePage";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";
import Impersonate from "@/pages/Impersonate";
import Billing from "@/pages/Billing";
import BillingReturn from "@/pages/BillingReturn";
import Support from "@/pages/Support";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Sales from "@/pages/Sales";
import Estimates from "@/pages/Estimates";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Purchases from "@/pages/Purchases";
import Expenses from "@/pages/Expenses";
import Inventory from "@/pages/Inventory";
import Banking from "@/pages/Banking";
import Parties from "@/pages/Parties";
import Reports from "@/pages/Reports";
import Insights from "@/pages/Insights";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth session_id synchronously during render (before ProtectedRoute runs)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/services/:slug" element={<ServicePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/refund" element={<Legal doc="refund" />} />
      <Route path="/confidentiality" element={<Legal doc="confidentiality" />} />
      <Route path="/disclaimer" element={<Legal doc="disclaimer" />} />
      <Route path="/impersonate/:token" element={<Impersonate />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/estimates" element={<Estimates />} />
        <Route path="/purchase-orders" element={<PurchaseOrders />} />
        <Route path="/purchases" element={<Purchases />} />
        <Route path="/expenses" element={<Expenses />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/banking" element={<Banking />} />
        <Route path="/parties" element={<Parties />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/billing/return" element={<BillingReturn />} />
        <Route path="/support" element={<Support />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
